// extracted by mini-css-extract-plugin
module.exports = {"dashed_ul":"dashedlist_dashed_ul__mN2O4","strongLi":"dashedlist_strongLi__wJnUa","normalLi":"dashedlist_normalLi__haQ_D"};